const inputFieldSize = "small";
export default inputFieldSize;